import { Injectable } from '@angular/core';

import { TargetingRhpContextsService } from '../../TargetingShared/services/targeting-rhp-contexts.service';

// Used for the monitoring results RHP
@Injectable()
export class MentionTargetingRhpContextsService extends TargetingRhpContextsService {
    // Override to not touch the outlet as this will be set from the mention data
    fetchContact(contactId: string, employmentIdToSelect?: number): Promise<void> {

        return new Promise<void> (resolve => {
            if (this.contact && contactId === this.contact.id && !this.contact.privateContactMetadata) {
                resolve();
            }

            this.contactId$.next(contactId);
            this.outletId$.next(null);
            this.contactLoading$.next(true);

            this.contactsPublicApi.getContact(contactId).subscribe({
                next: async contact => {
                    this.contact = await this.journodexEntityFactory.createContact(contact);
                    this.contact$.next(this.contact);
                    this.contactLoading$.next(false);


                    resolve();
                },
                error: () => {
                    this.contact$.next(null);
                    this.contactLoading$.next(false);
                    resolve();
                }
            });
        });
    }
}
